(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Resources.HyperChatSocial",
                {
                    url: "/HyperChatSocial",
                    component: "hyperchat",
                    PageTitle: "HyperChat Social",
                    //requiredPermissions: "HyperChatSocial:View",
                    resolve: {
                        states: ["states", function (states) {
                            return states;
                        }]
                    }
                });
        }
    ]);

    app.component("hyperchat",
        {
            templateUrl: "App/Resources/HyperChatSocial/hyperchatsocial.html",
            controller: hyperChatCtrl,
            bindings: {
                states: "<"
            }
        });

    hyperChatCtrl.$inject = ["amplitudeService"];

    function hyperChatCtrl(amplitudeService) {
        var $ctrl = this;

        $ctrl.logAmplitude = function (propertyName) {
            return amplitudeService.logClickEvent(propertyName);
        };
    }
})(window.app, window.angular); // jshint ignore:line